import React, { useEffect, useMemo, useState } from 'react';
import EditMenuButton from '../../Modal/EditMenuButton';
import { Box, Button, FormControl } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import ConfirmDeleteDialog from '../../Modal/ConfirmDelete';
import StatusApiService from '../../../api/StatusApiService';
import ModifyStatusModal from './ModifyStatusModal';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from '../../Common/SnackbarProvider';

const Statuses = () => {
    const snackbar = useSnackbar();
    const { t } = useTranslation();

    const [statuses, setStatuses] = useState([]);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState();

    const columns = useMemo(() => [
        {
            field: 'stId',
            headerName: t('common.id'),
            flex: 0.5,
        },
        {
            field: 'stName',
            headerName: t('statusesPage.column.name'),
            flex: 2,
        },
        {
            field: 'stSortSeq',
            headerName: t('fieldName.sortSequence'),
            flex: 2,
        },
        {
            field: 'edit',
            headerName: t('common.edit'),
            flex: 0.5,
            filterable: false,
            sortable: false,
            renderCell: (params) => {
                return <EditMenuButton
                    params={params}
                    setShowDeleteDialog={setShowDeleteDialog}
                    setCurrentSelectedRecord={setSelectedStatus}
                    onEditFunc={() => {
                        setShowEditDialog(true);
                        setSelectedStatus(params.row)
                    }}
                />;
            },
        }
    ], [t]);

    const statusApiService = new StatusApiService();

    async function getStatuses () {
        const statuses = await statusApiService.getStatuses();
        setStatuses(statuses.data);
    }

    async function onDeleteClick(value) {
        if (!value) {
            setShowDeleteDialog(false);
            return;
        }

        if (selectedStatus) {
            const deletedStatus = await statusApiService.deleteStatus(selectedStatus.stId);
            if (deletedStatus && deletedStatus.success) {
                snackbar.warning(t('statusesPage.toast.deleted'));
                await getStatuses();
            }
        }

        setShowDeleteDialog(false);
    }

    function handleEditClose() {
        setShowEditDialog(false);
        setSelectedStatus(null);
    }

    useEffect(() => {
        getStatuses();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showEditDialog])

    return(
        <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - var(--ct-header-h, 56px))' }}>
            <Box sx={{ mb: 2 }}>
                <h2>{t('statusesPage.title')}</h2>
            </Box>
            <Box sx={{ mb: 2 }}>
                <div style={{ display: 'inline-block', justifyContent: 'space-between' }}>
                    <FormControl sx={{ m: 1, minWidth: 120, float: 'left' }}>
                        <Button size={'large'} variant="contained" onClick={() => setShowEditDialog(true) }>{t('statusesPage.createButton')}</Button>
                    </FormControl>
                </div>
            </Box>
            <Box sx={{ flex: 1, minHeight: 0, width: '100%' }}>
                <DataGridPro
                    columns={columns}
                    rows={statuses}
                    getRowId={(row) => row.stId}
                    getRowHeight={() => 'auto'}
                />
            </Box>
            <ConfirmDeleteDialog
                onClose={onDeleteClick}
                open={showDeleteDialog}
            />
            <ModifyStatusModal
                open={showEditDialog}
                onClose={handleEditClose}
                selectedStatus={selectedStatus}
                statusApiService={statusApiService}
                onCancel={handleEditClose}
            />
        </Box>
    );
}

export default Statuses;
